<template>
  <v-container fluid>
    <navigation-drawer color="primary" dark app permanent>
      <v-card tile elevation="0">
        <v-row>
          <v-col class="primary text-center primary-light1--text">
            <v-row dense align="start">
              <v-col cols="auto">
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      class="ml-7"
                      v-on="on"
                      :attrs="attrs"
                      @click="redirectBackToQueue"
                    >
                      <div class="primary-light1--text">
                        <v-icon>mdi-chevron-left</v-icon>
                        <span>Filas</span>
                      </div>
                    </v-btn>
                  </template>
                  <span>Fila de Atendimento</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <v-row dense v-if="patient">
              <v-col>
                <v-avatar size="85">
                  <PatientPicture :avatar="patient.avatar" />
                </v-avatar>
              </v-col>
            </v-row>

            <v-row dense v-if="patient">
              <v-col class="font-weight-bold">
                {{ patient.name }}
              </v-col>
            </v-row>

            <v-row dense v-if="patient">
              <v-col class="font-weight-bold">
                {{ patient.warelineId }}
              </v-col>
            </v-row>

            <v-row dense v-if="patient">
              <v-col>
                {{ patient.birthDate | moment("DD/MM/Y") }}
              </v-col>
            </v-row>

            <v-row dense v-if="patient">
              <v-col>
                {{ formatedAge }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </navigation-drawer>

    <v-app-bar color="white" flat app>
      <v-tabs background-color="transparent" color="light-blue">
        <v-tab :to="`/pacientes/${patientId}/atendimentos`">Atendimentos</v-tab>
        <v-tab :to="`/pacientes/${patientId}/exames`">Exames</v-tab>
        <v-tab :to="`/pacientes/${patientId}/tratamentos`">Tratamentos</v-tab>
        <v-tab :to="`/pacientes/${patientId}/cirurgias`">Cirurgias</v-tab>
        <v-tab :to="`/pacientes/${patientId}/indicacoes-cirurgicas`">Indicações Cirúrgicas</v-tab>
        <v-tab :to="`/pacientes/${patientId}/dados-paciente`">Dados Paciente</v-tab>
      </v-tabs>
    </v-app-bar>

    <router-view v-if="!loading && patient" :patient="patient" />
    <v-container fluid v-else class="d-flex flex-column justify-center align-center" style="height: 100vh;">
      <div class="text-center mb-3">
        Aguarde, estamos buscando as informações do paciente, caso seja a primeira visita, iremos preparar as informações...
      </div>
      <v-progress-linear
        :value="progress"
        height="6"
        color="primary"
        class="w-50"
      ></v-progress-linear>
    </v-container>
  </v-container>
</template>

<script>
import PatientPicture from "@/components/queues/attendance/patient_picture.vue";
export default {
  components: {
    PatientPicture,
  },
  props: {
    patientId: String,
  },
  data() {
    return {
      redirectTo: "/",
      progress: 0,
      interval: null,
      loading: true,
    };
  },
  apollo: {
    patient: {
      query: require("@/graphql/patients/patient.gql"),
      variables() {
        return {
          patientId: this.patientId,
        };
      },
      result() {
        clearInterval(this.interval);
        this.progress = 100;
        this.loading = false;
      },
      error() {
        this.loading = false;
      },
    },
  },
  computed: {
    formatedAge() {
      if (!this.patient) return '';
      const diffDates = new Date() - new Date(this.patient.birthDate);
      const years = this.$moment.duration(diffDates).years();
      const months = this.$moment.duration(diffDates).months();

      const age = [];

      if (years === 1) {
        age.push(`${years} ano`);
      } else if (years > 1) {
        age.push(`${years} anos`);
      }

      if (months === 1) {
        age.push(`${months} mês`);
      } else if (months > 1) {
        age.push(`${months} meses`);
      }

      return age.join(" e ");
    },
    isCurrentUserDoctor() {
      return this.$store.state.authentication?.user?.employee?.employee_type == "doctor"
    },
  },
  mounted() {
    this.startProgress();
    this.loading = this.$apollo.queries.patient.loading;
  },
  methods: {
    startProgress() {
      this.progress = 0;
      const duration = 60000; // 60 seconds
      const intervalDuration = 100; // 100 ms
      const increment = (intervalDuration / duration) * 100;
      this.interval = setInterval(() => {
        if (this.progress < 100) {
          this.progress += increment;
        } else {
          clearInterval(this.interval);
        }
      }, intervalDuration);
    },
    redirectBackToQueue() {
      if (this.isCurrentUserDoctor) {
        this.$router.push("/filas/medico");
        return;
      }
      this.$router.push(this.redirectTo);
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped></style>

